module.exports = __webpack_public_path__ + "images/bb.png?ab45e070865dc3c8a58b17e8cf07702c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bb.png
// module id = 47
// module chunks = 0